import { render } from "./ForSale.vue?vue&type=template&id=62ca657b&scoped=true"
import script from "./ForSale.vue?vue&type=script&lang=js"
export * from "./ForSale.vue?vue&type=script&lang=js"

import "./ForSale.vue?vue&type=style&index=0&id=62ca657b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ca657b"]])

export default __exports__